import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css"; // Import default CSS for Calendar
// import "./hrDashboard.css"; // Custom styles for the calendar
import { Card, Form, Space, Table } from "antd";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
import moment from "moment";

const HRDashboard: React.FC = () => {
  const [date, setDate] = useState<Date | null>(new Date());
  const [holidays, setHolidays] = useState<{ [key: string]: string }>({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5); // Define the page size
  const [data, setData] = useState<any>([]);
  const [clientdata, setClientData] = useState<any>([]);
  const [projectdata, setprojectData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [meta, setMeta] = useState<any>({});
  const [metas, setsMeta] = useState<any>({});
  const [metasss, setsMetass] = useState<any>({});
  const [filterData, setFilterData] = useState<any>([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // Handle date change
  const handleDateChange = (value: any | [Date, Date] | null) => {
    setDate(value);
  };
  const fetchHrEmployee = async (page: any) => {
    try {
      setIsLoading(true);
      let obj = {
        // query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_EMPLOYEE;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrEmployee(page);
  }, [page]); // Fetch data on page or pageSize change

  const filterEmployee = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        status: true,
      };
      const url = API.FILTER_EMPLOYEE;
      const response: any = await POST(url, obj);
      setFilterData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    filterEmployee(); // Fetch data when the component mounts
  }, []);

  const fetchHrproject = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_PROJECT;
      const response: any = await POST(url, obj);
      setprojectData(response?.data);

      setsMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrproject(page, pageSize);
  }, [page, pageSize]);

  const fetchHrclient = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_CLIENT;
      const response: any = await POST(url, obj);
      setClientData(response?.data);

      setsMetass(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrclient(page, pageSize);
  }, [page, pageSize]);
  // console.log("object", meta?.total_count);

  const columns = [
    {
      dataIndex: "projectName",
      title: "projectName",
    },
    {
      title: "status",
      dataIndex: "status",
    },
    {
      key: "assignedTo",
      dataIndex: "assignedTo",
      title: "assignedTo",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "clientid",
      title: "clientid",
      key: "clientid",
      render: (_: any, value: any) => <span>{value?.Client?.companyName}</span>,
    },
    {
      dataIndex: "endDate",
      title: "endDate",
      render: (end_date: any) =>
        end_date ? moment(end_date).format("DD/MM/YYYY") : "-",
    },

    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/HR/Project/projectview/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];
  return (
    <div className="dashboard-container">
      <div className="card-container">
        <Card className="main-card">
          <h2 style={{ textAlign: "center" }}>
            Total Employees: {meta?.total_count}
          </h2>
          <div className="grid-container">
            <Card
              className="inner-card"
              onClick={() => navigate("/HR/Accountant")}
            >
              <h6>Accountants</h6>
              {
                filterData?.filter((emp: any) => emp.type === "accountant")
                  .length
              }
            </Card>
            <Card
              className="inner-card"
              onClick={() => navigate("/HR/Developer")}
            >
              <h6>Developers</h6>

              {
                filterData?.filter((emp: any) => emp.type === "developer")
                  .length
              }
            </Card>
            <Card
              className="inner-card"
              onClick={() => navigate("/HR/Designer")}
            >
              <h6>Designers</h6>

              {filterData?.filter((emp: any) => emp.type === "designer").length}
            </Card>
            <Card
              className="inner-card"
              onClick={() => navigate("/HR/Telecaller")}
            >
              <h6>Telecallers</h6>

              {
                filterData?.filter((emp: any) => emp.type === "telecaller")
                  .length
              }
            </Card>
          </div>
        </Card>
        <Card className="main-card" onClick={() => navigate("/HR/Project")}>
          <h2 style={{ textAlign: "center" }}>
            Total Projects: {metas?.total_count}
          </h2>
          <div className="grid-container">
            {/* Completed Projects */}
            <Card className="inner-card">
              <h6>Completed</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) =>
                    project.status === "completed"
                ).length
              }
            </Card>

            {/* Pending Projects */}
            <Card className="inner-card">
              <h6>Pending</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) => project.status === "pending"
                ).length
              }
            </Card>

            {/* Running Projects */}
            <Card className="inner-card">
              <h6>Running</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) => project.status === "running"
                ).length
              }
            </Card>

            {/* In Progress Projects */}
            <Card className="inner-card">
              <h6>In Progress</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) =>
                    project.status === "in-progress"
                ).length
              }
            </Card>
          </div>
        </Card>
        <Card className="main-card" onClick={() => navigate("/HR/Client")}>
          <h2 style={{ textAlign: "center" }}>
            Total Clients: {metasss?.total_count || 0}
          </h2>
          <div className="grid-container">
            {clientdata?.length > 0 ? (
              clientdata.map((client: any, index: number) => (
                <Card className="inner-card" key={index}>
                  <h6>{client.companyName}</h6>
                </Card>
              ))
            ) : (
              <p style={{ textAlign: "center", margin: "20px auto" }}>
                No clients available
              </p>
            )}
          </div>
        </Card>
      </div>
      <div className="dashboard-container">
        <div className="dashboard-row">
          <Card className="calendar-card">
            <h3 className="selected-date">
              {date
                ? `Selected Date: ${
                    date instanceof Date ? date.toDateString() : ""
                  }`
                : "No date selected"}
            </h3>
            <div className="calendar-container">
              <Calendar
                onChange={handleDateChange} // Now accepts Date, Range, or null
                value={date}
                tileContent={({ date, view }) => {
                  const formattedDate = date.toISOString().split("T")[0];
                  if (view === "month" && holidays[formattedDate]) {
                    return (
                      <div className="holiday-marker">
                        {holidays[formattedDate]}
                      </div>
                    );
                  }
                  return null;
                }}
              />
            </div>
          </Card>
          <Card className="table-card">
            <Table
              columns={columns}
              dataSource={projectdata}
              pagination={{
                current: page,
                pageSize: pageSize,
                total: meta?.total_count,
                onChange: (page: any, pageSize: any) => {
                  setPage(page);
                  setPageSize(pageSize);
                },
              }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default HRDashboard;
